import I18nLocaleEnum from './i18n/i18nLocale.enum';
import { PartnerRoleEnum } from '@/types/models/partner.type';

export interface IntercomPartnerProfile {
  id: number;
  name: string;
  email: string;
  role: null | PartnerRoleEnum;
  intercom_user_jwt?: string;
}

export interface IntercomBootSettings {
  app_id: string | undefined;
  intercom_user_jwt: string;
  user_id: string;
  api_base: string;
  zam_ID: number;
  name: string;
  email: string;
  language_override: I18nLocaleEnum;
}

const INTERCOM_API_BASE = 'https://api-iam.intercom.io';
let intercomLifecycleVersion = 0;

export const getIntercomLifecycleVersion = (): number => intercomLifecycleVersion;

export const createIntercomBootSettings = (
  profile: IntercomPartnerProfile | null | undefined,
  isAuthenticated: boolean,
): IntercomBootSettings | null => {
  if (
    !isAuthenticated ||
    !profile ||
    profile.role !== null ||
    !profile.id ||
    !profile.name ||
    !profile.email ||
    !profile.intercom_user_jwt
  )
    return null;

  return {
    app_id: process.env.VUE_APP_INTERCOM_APP_ID,
    intercom_user_jwt: profile.intercom_user_jwt,
    user_id: `${profile.id}`,
    api_base: INTERCOM_API_BASE,
    zam_ID: profile.id,
    name: profile.name,
    email: profile.email,
    language_override: I18nLocaleEnum.en,
  };
};

export const bootIntercom = (
  profile: IntercomPartnerProfile | null | undefined,
  isAuthenticated: boolean,
  expectedLifecycleVersion?: number,
): boolean => {
  if (expectedLifecycleVersion !== undefined && expectedLifecycleVersion !== intercomLifecycleVersion) return false;

  const settings = createIntercomBootSettings(profile, isAuthenticated);
  if (!settings || typeof window.Intercom !== 'function') return false;

  window.Intercom('boot', settings as unknown as Intercom_.IntercomSettings);
  return true;
};

export const shutdownIntercom = (): void => {
  intercomLifecycleVersion += 1;
  if (typeof window.Intercom === 'function') window.Intercom('shutdown');
};
